/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgStrikethroughKorean = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M2048 896v128h-128v512h-128v-512h-512v144h92q45 0 93 1 60 0 120-5t120-19l17 110q-34 8-79 13t-95 8-104 4-105 1h-102q-48 0-85-1v-256H896v512H768v-512H436q-63 101-149 180T99 1347l-99-93q81-45 153-101t129-129H0V896h362q34-70 50-145H59V640h503q-6 66-21 130t-40 126h267V512h128v384h256V640h128v256h512V512h128v384h128z"
    }));
export default SvgStrikethroughKorean;
